import React from 'react';
import IpWhitelistGuard from './IpWhitelistGuard';
import Login from '../pages/Login';

const LoginWithIpCheck: React.FC = () => {
  console.log('LoginWithIpCheck: Rendering component');
  return (
    <IpWhitelistGuard>
      <Login />
    </IpWhitelistGuard>
  );
};

export default LoginWithIpCheck;
